import { apiUploadPublisherAssetsRestricted } from './api';

export async function uploadRestrictedAssets (props) {
    const publisher = this.env.userStore.publisher;
    const formData = new FormData();
    formData.append('assetType', props.assetType);
    formData.append('file', props.file);

    const res = await apiUploadPublisherAssetsRestricted({
        data: formData,
        token: publisher.token,
        traceId: this.env.traceId,
        bypassRestriction: props.bypassRestriction,
    });
    return res;
}
